/**
 * Server-only data sources for server rendering.
 *
 * The server requires the built client bundle, so bundled code can't import
 * server modules (mongoose and friends). Instead the server registers plain
 * async functions here at boot, through the setters exported from
 * src/index.js, and thunks use them when there is no window. In the browser
 * nothing is registered and the getters return null.
 */
let skillsAndToolsSource = null;

/**
 * @param {(() => Promise<{ skills: object[], tools: object[], categories: object[] }>) | null} fn
 */
export const setSkillsAndToolsSource = fn => {
  skillsAndToolsSource = fn;
};

export const getSkillsAndToolsSource = () => skillsAndToolsSource;
